<div class="chip" [ngClass]="'agent-' + agent?.role">
  <span class="circle">{{ agent?.name | lmsInitials }}</span> {{ agent?.name }}
  {{ agent?.surname }}
  <span *ngIf="agent?.clientName">({{ agent?.clientName }})</span>
  <span *ngIf="agent?.role === 'csm' || agent?.role === 'supportSpecialist' || agent?.role === 'csAdmin'" class="right"
    >&nbsp;({{ agent?.role | uppercase }})</span
  >
</div>
